<div class="sidebar-wrapper">
  <!-- Mobile Close Button -->
  <div class="mobile-close-container" *ngIf="isMobileView">
    <button class="mobile-close-btn" (click)="closeMobileSidebar.emit()" aria-label="Close sidebar">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Header Section -->
  <div class="sidebar-header">
    <div class="logo-section">
      <img src="../../assets/img/hc-logo-clean.png" alt="Logo" class="logo-img" style="width: 40px; height: 40px;" />
      <div class="brand-info">
        <span class="brand-title">HarperCollins AI</span>
        <span class="brand-subtitle">Multi-Modal Chatbot</span>
      </div>
    </div>
  </div>

  <!-- New Chat Button -->
  <button class="new-chat-btn btn-outline-primary" (click)="startNewChat()">
    <i class="bi bi-plus-lg"></i>
    <span>New Chat</span>
  </button>

  <!-- Divider -->
  <div class="section-divider"></div>

  <!-- Search Box -->
  <div class="search-container">
    <i class="bi bi-search search-icon"></i>
    <input type="text" class="search-input" placeholder="Search chats..." [(ngModel)]="searchTerm">
  </div>

  <!-- Chat Sessions List -->
  <div class="sessions-list">
    <!-- Pinned Sessions Section -->
    <div class="pinned-section" *ngIf="pinnedSessions.length > 0">
      <div class="section-label">
        <i class="bi bi-pin-angle-fill"></i>
        <span>Pinned</span>
      </div>
      <a *ngFor="let session of pinnedSessions" href="#" class="session-item pinned"
        [class.active]="currentSessionId === session.id" (click)="loadSession(session.id)">

        <i class="bi bi-pin-fill pin-indicator"></i>
        <span class="session-name" [title]="session.name || session.title" *ngIf="editingSessionId !== session.id">
          {{ session.name || session.title }}
        </span>
        <span *ngIf="!isSessionModelAvailable(session) && editingSessionId !== session.id" class="model-badge">Model
          Unavailable</span>

        <!-- 3-dot menu button -->
        <div class="session-menu-wrapper" *ngIf="editingSessionId !== session.id">
          <button class="menu-btn"
            (click)="$event.preventDefault(); $event.stopPropagation(); toggleSessionMenu(session.id, $event)"
            title="More options">
            <i class="bi bi-three-dots"></i>
          </button>

          <!-- Dropdown Menu -->
          <div class="session-dropdown"
            [class.active]="openMenuSessionId === session.id"
            [style.top.px]="sessionDropdownTop"
            [style.left.px]="sessionDropdownLeft">
            <button class="dropdown-item" (click)="$event.stopPropagation(); startEditTitle(session, $event)">
              <i class="bi bi-pencil"></i>
              <span>Rename</span>
            </button>
            <button class="dropdown-item" (click)="$event.stopPropagation(); togglePinSession(session, $event)">
              <i class="bi bi-pin-angle"></i>
              <span>Unpin chat</span>
            </button>
            <button class="dropdown-item delete" (click)="$event.stopPropagation(); deleteSession(session.id)">
              <i class="bi bi-trash"></i>
              <span>Delete</span>
            </button>
          </div>
        </div>

        <div class="edit-mode" *ngIf="editingSessionId === session.id" (click)="$event.stopPropagation()">
          <input type="text" class="edit-input" [(ngModel)]="editedTitle"
            (keydown.enter)="saveEditedTitle(session, $event)" (keydown.escape)="cancelEditTitle($event)"
            placeholder="Enter title" />
          <button class="action-btn save-btn" title="Save" (click)="saveEditedTitle(session, $event)">
            <i class="bi bi-check"></i>
          </button>
          <button class="action-btn cancel-btn" title="Cancel" (click)="cancelEditTitle($event)">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </a>
    </div>

    <!-- Regular Sessions Section -->
    <div class="regular-section">
      <a *ngFor="let session of unpinnedSessions" href="#" class="session-item"
        [class.active]="currentSessionId === session.id" (click)="loadSession(session.id)">

        <span class="session-name" [title]="session.name || session.title" *ngIf="editingSessionId !== session.id">
          {{ session.name || session.title }}
        </span>
        <span *ngIf="!isSessionModelAvailable(session) && editingSessionId !== session.id" class="model-badge">Model
          Unavailable</span>

        <!-- 3-dot menu button -->
        <div class="session-menu-wrapper" *ngIf="editingSessionId !== session.id">
          <button class="menu-btn"
            (click)="$event.preventDefault(); $event.stopPropagation(); toggleSessionMenu(session.id, $event)"
            title="More options">
            <i class="bi bi-three-dots"></i>
          </button>

          <!-- Dropdown Menu -->
          <div class="session-dropdown"
            [class.active]="openMenuSessionId === session.id"
            [style.top.px]="sessionDropdownTop"
            [style.left.px]="sessionDropdownLeft">
            <button class="dropdown-item" (click)="$event.stopPropagation(); startEditTitle(session, $event)">
              <i class="bi bi-pencil"></i>
              <span>Rename</span>
            </button>
            <button class="dropdown-item" (click)="$event.stopPropagation(); togglePinSession(session, $event)">
              <i class="bi bi-pin-angle"></i>
              <span>Pin chat</span>
            </button>
            <button class="dropdown-item delete" (click)="$event.stopPropagation(); deleteSession(session.id)">
              <i class="bi bi-trash"></i>
              <span>Delete</span>
            </button>
          </div>
        </div>

        <div class="edit-mode" *ngIf="editingSessionId === session.id" (click)="$event.stopPropagation()">
          <input type="text" class="edit-input" [(ngModel)]="editedTitle"
            (keydown.enter)="saveEditedTitle(session, $event)" (keydown.escape)="cancelEditTitle($event)"
            placeholder="Enter title" />
          <button class="action-btn save-btn" title="Save" (click)="saveEditedTitle(session, $event)">
            <i class="bi bi-check"></i>
          </button>
          <button class="action-btn cancel-btn" title="Cancel" (click)="cancelEditTitle($event)">
            <i class="bi bi-x"></i>
          </button>
        </div>
      </a>
    </div>

    <div *ngIf="isLoadingSessions" class="sessions-loading">
      <span class="loading-spinner"></span>
      <span>Loading chats...</span>
    </div>
    <p *ngIf="!isLoadingSessions && filteredChatSessions.length === 0" class="empty-state">
      No chat sessions found.
    </p>
  </div>

  <!-- LLM Controls Section -->
  <div class="sidebar-controls">
    <!-- Header -->
    <div class="creativity-header">
      <span class="creativity-label">Models</span>
    </div>
    <!-- <div class="controls-header">
      <span>LLM Models</span>
    </div> -->
    
    <!-- LLM Models Hover Menu -->
    <div class="control-group">
      <div class="sidebar-menu-item" #modelMenuItem (mouseenter)="onModelMenuHover($event)"
        (mouseleave)="onModelMenuLeave()">
        <div class="menu-item-label">
          <!-- <i class="bi bi-cpu"></i> -->
          <span>{{ getCurrentModelName() }}</span>
        </div>
        <i class="bi bi-chevron-right menu-arrow"></i>

        <!-- Model List - Shows on right on hover -->
        <div class="model-submenu" #modelSubmenu (mouseenter)="onSubmenuHover()" (mouseleave)="onModelMenuLeave()">
          <div class="model-submenu-item" *ngFor="let model of availableModels"
            [class.active]="selectedModel === model.slug"
            [class.image-model]="model.isImageModel"
            (click)="selectedModel = model.slug; onModelChange()">
            <span>
              <svg *ngIf="model.isImageModel" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 6px; vertical-align: -2px; opacity: 0.7;">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
              </svg>
              {{ model.name }}
            </span>
            <i class="bi bi-check-circle-fill" *ngIf="selectedModel === model.slug"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Options (shown only for image models) -->
    <div class="image-options-compact" *ngIf="isImageModel()">
      <div class="image-option-row">
        <span class="option-label">Size</span>
        <select class="option-select" [ngModel]="imageSize" (ngModelChange)="onImageSizeChange($event)">
          <option *ngFor="let size of imageSizes" [value]="size.value">{{ size.label }}</option>
        </select>
      </div>
      <div class="image-option-row">
        <span class="option-label">Quality</span>
        <select class="option-select" [ngModel]="imageQuality" (ngModelChange)="onImageQualityChange($event)">
          <option *ngFor="let quality of imageQualities" [value]="quality.value">{{ quality.label }}</option>
        </select>
      </div>
      <div class="image-option-row">
        <span class="option-label">Style</span>
        <select class="option-select" [ngModel]="imageStyle" (ngModelChange)="onImageStyleChange($event)">
          <option *ngFor="let style of imageStyles" [value]="style.value">{{ style.label }}</option>
        </select>
      </div>
    </div>

    <!-- Creativity Slider -->
    <div class="control-group" *ngIf="selectedModel !== 'gpt-5-mini' && !isImageModel()">
      <div class="creativity-header">
        <span class="creativity-label">Creativity</span>
      </div>
      <div class="slider-wrapper">
        <input type="range" class="creativity-slider" min="0" max="1" step="0.5" [(ngModel)]="creativityValue"
          (change)="onCreativityChange()">
        <div class="slider-labels">
          <span class="slider-min" [class.active]="creativityValue === 0">low</span>
          <span class="slider-middle" [class.active]="creativityValue === 0.5">medium</span>
          <span class="slider-max" [class.active]="creativityValue === 1">high</span>
        </div>
      </div>
    </div>

    <!-- Reasoning Level (for GPT-5 Mini) - Slider Design -->
    <div class="control-group" *ngIf="selectedModel === 'gpt-5-mini' && !isImageModel()">
      <div class="creativity-header">
        <span class="creativity-label">Reasoning</span>
      </div>
      <div class="slider-wrapper">
        <input type="range" class="creativity-slider" min="0" max="1" step="0.5" [(ngModel)]="reasoningValue"
          (change)="onReasoningValueChange()">
        <div class="slider-labels">
          <span class="slider-min" [class.active]="reasoningValue === 0">low</span>
          <span class="slider-middle" [class.active]="reasoningValue === 0.5">medium</span>
          <span class="slider-max" [class.active]="reasoningValue === 1">high</span>
        </div>
      </div>
    </div>

    <!-- Reasoning Level (for Gemini 2.5 Pro) - Slider Design -->
    <div class="control-group" *ngIf="isGemini25Pro() && !isImageModel()">
      <div class="creativity-header">
        <span class="creativity-label">Reasoning</span>
      </div>
      <div class="slider-wrapper">
        <input type="range" class="creativity-slider" min="0" max="1" step="0.5" [value]="getReasoningValue()"
          (input)="onReasoningSliderChange(+$any($event.target).value)">
        <div class="slider-labels">
          <span class="slider-min" [class.active]="getReasoningValue() === 0">low</span>
          <span class="slider-middle" [class.active]="getReasoningValue() === 0.5">medium</span>
          <span class="slider-max" [class.active]="getReasoningValue() === 1">high</span>
        </div>
      </div>
    </div>
  </div>
</div>